
module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/~/engine.io-client/index.js
 ** module id = 405
 ** module chunks = 0
 **/